module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "icon-engine.f1c291eb.png";